import { svg } from 'lit';

export const caretRightIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7071 5.29286L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.4211 18.9931 9.99099 19.0786 9.61732 18.9238C9.24364 18.7691 9 18.4044 9 18V5.99997C9 5.59551 9.24364 5.23087 9.61732 5.07609C9.99099 4.92131 10.4211 5.00686 10.7071 5.29286Z" fill="currentColor"/>
  `;
